require('./js/angular-daterangepicker.js');
module.exports = 'daterangepicker'



//////////////////
// WEBPACK FOOTER
// ./~/angular-daterangepicker/index.js
// module id = 379
// module chunks = 0